import { FC, ReactNode, createContext, useContext, useMemo } from 'react';
import { useIsUserInChina } from 'services/api/useDashboard';
import { GeoLocationContextValue } from './typings';

interface GeoLocationProviderProps {
  children: ReactNode;
}

export const GeoLocationContext = createContext<GeoLocationContextValue>({
  isChinaUser: false,
  chinaUserResponseLoading: false,
});

export const GeoLocationProvider: FC<GeoLocationProviderProps> = ({ children }) => {
  const { data: isChinaUser, isLoading: chinaUserResponseLoading } = useIsUserInChina();

  const contextValue = useMemo(
    () => ({
      isChinaUser,
      chinaUserResponseLoading,
    }),
    [isChinaUser, chinaUserResponseLoading],
  );

  return <GeoLocationContext.Provider value={contextValue}>{children}</GeoLocationContext.Provider>;
};

export const useGeoLocationContext = (): GeoLocationContextValue => {
  const context = useContext(GeoLocationContext);

  if (context === undefined) {
    throw new Error('GeoLocationContext must be used within a GeoLocationProvider');
  }

  return context;
};

export default GeoLocationProvider;
